module.exports = __webpack_public_path__ + "img/roof-01.df8faa74.png";